import request from '@/utils/request'

const baseURL = '/seizure-land-inventories'

export default {
  list(params = {}) {
    return request({
      url: baseURL,
      method: 'get',
      params,
    })
  },

  moduleTabs() {
    return request({
      url: `${baseURL}/module-tabs`,
      method: 'get',
    })
  },

  show(id) {
    return request({
      url: `${baseURL}/${id}`,
      method: 'get',
    })
  },

  store(formData) {
    return request({
      url: baseURL,
      method: 'post',
      data: formData,
    })
  },

  update(id, data) {
    const multipart = typeof FormData !== 'undefined' && data instanceof FormData
    return request({
      url: `${baseURL}/${id}`,
      method: multipart ? 'post' : 'put',
      data,
    })
  },

  destroy(id) {
    return request({
      url: `${baseURL}/${id}`,
      method: 'delete',
    })
  },

  updateTeam(id, data) {
    return request({
      url: `${baseURL}/${id}/team`,
      method: 'put',
      data,
    })
  },

  checkDuplicate(data) {
    return request({
      url: `${baseURL}/check-duplicate`,
      method: 'post',
      data,
    })
  },

  addAttachments(id, formData) {
    return request({
      url: `${baseURL}/${id}/attachments`,
      method: 'post',
      data: formData,
    })
  },

  linkParcel(inventoryId, parcelId, data = { auto: true }) {
    return request({
      url: `${baseURL}/${inventoryId}/parcels/${parcelId}/link`,
      method: 'post',
      data,
    })
  },

  createEncroachmentProject(inventoryId, encroachmentId, data = {}) {
    return request({
      url: `${baseURL}/${inventoryId}/encroachments/${encroachmentId}/create-project`,
      method: 'post',
      data,
    })
  },

  createProject(id, data = {}) {
    return request({
      url: `${baseURL}/${id}/create-project`,
      method: 'post',
      data,
    })
  },

  listMaps(params = {}) {
    return request({
      url: `${baseURL}/maps`,
      method: 'get',
      params,
    })
  },

  storeMap(formData) {
    return request({
      url: `${baseURL}/maps`,
      method: 'post',
      data: formData,
    })
  },

  updateMap(id, formData) {
    const multipart = typeof FormData !== 'undefined' && formData instanceof FormData
    if (multipart && !formData.has('_method')) {
      formData.append('_method', 'PUT')
    }
    return request({
      url: `${baseURL}/maps/${id}`,
      method: multipart ? 'post' : 'put',
      data: formData,
    })
  },

  returnMap(id, formData) {
    return request({
      url: `${baseURL}/maps/${id}/return`,
      method: 'post',
      data: formData,
    })
  },

  encroachmentParcelLinksReport(params = {}) {
    return request({
      url: `${baseURL}/reports/encroachment-parcel-links`,
      method: 'get',
      params,
    })
  },

  coordinateSequenceReport(params = {}) {
    return request({
      url: `${baseURL}/reports/coordinate-sequence`,
      method: 'get',
      params,
    })
  },
}
